export const DEBOUNCE_DELAY = 500;

export function debounce(fn, delay = DEBOUNCE_DELAY) {
    let timer;

    const debounced = (...args) => {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            fn(...args);
            timer = null;
        }, delay);
    };

    debounced.cancel = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    return debounced;
}

export const getParsedValue = (field) => parseInt(field?.innerText, 10) || 0;

export class CountdownTimer {
    constructor(timeConfig, fields) {
        if (typeof timeConfig === "object" && timeConfig !== null) {
            const {
                days = 0,
                hours = 0,
                minutes = 0,
                seconds = 0,
            } = timeConfig;

            this.totalSeconds =
                days * 86400 + hours * 3600 + minutes * 60 + seconds;
        } else {
            this.totalSeconds = timeConfig;
        }

        this.fields = fields;
        this.timerId = null;
    }

    start() {
        this.timerId = setInterval(() => {
            if (this.totalSeconds <= 0) {
                clearInterval(this.timerId);
                return;
            }

            this.totalSeconds--;

            if (this.fields.days) {
                const days = Math.floor(this.totalSeconds / 86400);
                const hours = Math.floor((this.totalSeconds % 86400) / 3600);
                const minutes = Math.floor((this.totalSeconds % 3600) / 60);
                this.fields.days.innerText = days;
                this.fields.hours.innerText = hours;
                this.fields.minutes.innerText = minutes;
            } else {
                const hours = Math.floor(this.totalSeconds / 3600);
                const minutes = Math.floor((this.totalSeconds % 3600) / 60);
                const seconds = this.totalSeconds % 60;
                this.fields.hours.innerText = hours;
                this.fields.minutes.innerText = minutes;

                if (this.fields.seconds) {
                    this.fields.seconds.innerText = seconds;
                }
            }
        }, 1000);
    }

    stop() {
        clearInterval(this.timerId);
    }
}
